import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
} from "@material-ui/core";
import { useClientData } from "./hooks/useClientData";
import "./styles.scss";

const InfoModal = ({ userInfo, onClose }) => {
  const { clientName, clientNumber, childAge, childName } =
    useClientData(userInfo);

  return (
    <Dialog open={!!userInfo} onClose={onClose} fullWidth={true}>
      <DialogTitle>
        {!!childName && <div>{childName}</div>}
        {!!childAge && <div>{childAge}</div>}
      </DialogTitle>

      <DialogContent>
        <p className="info-modal__line">Информация о родителе:</p>

        <p className="info-modal__line">
          ФИО: <span className="info-modal__line-value">{clientName}</span>
        </p>
        <p className="info-modal__line">
          Номер телефона:{" "}
          <span className="info-modal__line-value">{clientNumber}</span>
        </p>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary">
          <a
            className="info-modal__link"
            href={`https://wa.me/${clientNumber}`}
            target={"_blank"}
          >
            WhatsApp
          </a>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InfoModal;
